import { render, staticRenderFns } from "./productManage.vue?vue&type=template&id=9703ce58&"
import script from "./productManage.vue?vue&type=script&lang=js&"
export * from "./productManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports